<template>
  <div class="wedding-root">
    <div id="ceremony-info">
      <place-of-interest
        :image="$assets.confetti"
        title="Celebration"
      >
        <p>
          Mariette and Kit were married in England, and as such there will be no formal ceremony. A
          small vow ceremony will be held at Mariette’s parents’ house, primarily for the benefit of
          Mariette’s grandmothers. Please contact Mariette if you wish to attend, but be aware that
          there is very limited space.
        </p>
      </place-of-interest>
    </div>
    <div id="reception-info">
      <place-of-interest
        title="Reception"
        :image="$assets.simonsig"
      >
        <p>
          The reception will take place at Cuvee on the beautiful wine farm Simonsig, just outside
          of Stellenbosch. Welcome drinks will be served from 18:00, thereafter follows a relaxed
          reception with a 3 course meal, some of Simonsig’s older vintages, good company. After the
          meal there will be a cash bar, and potentially dancing if Mariette’s father can be
          convinced. The reception will end at 23:00. We so look forward to seeing you there.
        </p>
      </place-of-interest>
    </div>
  </div>
</template>

<script>
  import PlaceOfInterest from '../components/PlaceOfInterest.vue'

  export default {
    name: 'Wedding',
    components: { PlaceOfInterest },
  }
</script>

<style lang="scss" scoped>
  #house-info::before {
    content: '';
    display: block;
    height: 75px;
    margin-top: -75px;
  }

  .wedding-root {

    & > div {
      &:nth-child(even) {
        --poi-reverse: true;
      }

      &:nth-child(odd) {
        --poi-reverse: false;
      }
    }

    p {
      text-align: justify;
    }
  }

</style>
